import { createAction } from '@reduxjs/toolkit';
import QuizAgentMessage from 'models/QuizAgentMessage';

export const appendStreamChunk = createAction<{
  draftQuiz?: any;
  activities?: string[];
}>('quizAgent/appendStreamChunk');

export const completeStream = createAction<{
  message?: QuizAgentMessage | null;
  draftQuiz?: any;
}>('quizAgent/completeStream');
